import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  inject: true
});

VeeValidate.Validator.extend('uniqueInArray', {
  getMessage: field => `The ${field} must be unique`,
  validate: (value, array) =>  array.indexOf(value) === -1
})